/**
 * Repository for obtaining Entities by their ID or as a list
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

import { Repository } from "./Repository.js";

export class ExhibitionRepository extends Repository {

    constructor() {
		super();
        this.map = {};
		this.list = [];

		// lists by state
		this.activeEntry = null;
		this.previewList = [];
		this.archiveList = [];

		this.today = new Date().toISOString().slice(0, 10);
    }
	
	register(exhibition) {
		this.map [exhibition.getID()] = exhibition;
		this.list.push(exhibition);

		if (this.today.localeCompare(exhibition.getStartDate()) < 0) {
			// Start Date in the Future -> Preview
			exhibition.setActive(-1);		
			this.previewList.push(exhibition);
		} else {
			// Start Date in the past
			if (this.activeEntry == null) {
				// and no active yet => active
				exhibition.setActive(1);	
				this.activeEntry = exhibition;
			} else {
				// otherwise archived
				exhibition.setActive(2);		
				this.archiveList.push(exhibition);
			}
		}
	}

	getActive() {
		return this.activeEntry;
	}

	getPreview() {
		return this.previewList;
	}

	getArchive() {
		return this.archiveList;
	}

}